import i18n from '../i18n';
import {
  getSupportedLanguage,
  isRtlLanguage,
  setStoredLanguage,
} from '../i18nLanguages';

const applyLanguagePreference = (language) => {
  const supportedLanguage = getSupportedLanguage(language);
  if (!supportedLanguage) return null;

  const currentLanguage = getSupportedLanguage(
    i18n.resolvedLanguage || i18n.language
  );

  if (currentLanguage !== supportedLanguage) {
    i18n.changeLanguage(supportedLanguage);
  }

  setStoredLanguage(supportedLanguage);

  if (typeof document !== 'undefined') {
    document.documentElement.lang = supportedLanguage;
    document.documentElement.dir = isRtlLanguage(supportedLanguage)
      ? 'rtl'
      : 'ltr';
  }

  return supportedLanguage;
};

export default applyLanguagePreference;
